module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "checkout"
  }, [_c('div', {
    staticClass: "address",
    on: {
      "click": function($event) {
        return _vm.goToAddressList()
      }
    }
  }, [_c('i', {
    staticClass: "pos-icon"
  }), _vm._v(" "), (_vm.address && _vm.address.name) ? _c('div', {
    staticClass: "address-info"
  }, [_c('p', {
    staticClass: "user"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.address.name))]), _vm._v(" "), _c('span', {
    staticClass: "tel"
  }, [_vm._v(_vm._s(_vm.address.tel))])]), _vm._v(" "), _c('p', {
    staticClass: "street"
  }, [_vm._v("\n          " + _vm._s(_vm.address.street) + "\n        ")])]) : _vm._e(), _vm._v(" "), (!_vm.address || !_vm.address.name) ? _c('div', {
    staticClass: "address-info"
  }, [_c('p', {
    staticClass: "user"
  }, [_vm._v("\n          添加地址\n        ")])]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "more-icon"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("商品清单")]), _vm._v(" "), _c('ul', {}, _vm._l((_vm.cartGoods), function(g) {
    return _c('li', {
      key: g.name + g.spec
    }, [_c('p', {
      staticClass: "cart-item"
    }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("¥" + _vm._s(Math.round(g.quantity * (g.customerPrice || g.price) * 100) / 100))]), _vm._v(" "), (g.unit2) ? _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("(约" + _vm._s(Number(g.quantity).toFixed(2)) + _vm._s(g.unit || '斤') + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "quantity"
    }, [_vm._v(_vm._s(g.quantity / Number((g.unit2 && g.priceTransfer || 1))) + _vm._s(g.unit2 || g.unit || '斤'))])])])
  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "total-fee"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("总计")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("¥" + _vm._s(_vm.totalPrice))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("配送时间")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryTime),
      expression: "deliveryTime"
    }],
    attrs: {
      "name": "",
      "id": "time-select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.deliveryTime = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "明天10:00-11:00"
    }
  }, [_vm._v("明天10:00-11:00")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "明天9:00-10:00"
    }
  }, [_vm._v("明天9:00-10:00")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "明天8:00-9:00"
    }
  }, [_vm._v("明天8:00-9:00")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "明天7:00-8:00",
      "selected": "selected"
    }
  }, [_vm._v("明天7:00-8:00")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "明天6:00-7:00"
    }
  }, [_vm._v("明天6:00-7:00")])]), _vm._v(" "), _c('i', {
    staticClass: "more-select"
  })]), _vm._v(" "), _c('div', {
    staticClass: "order-notes"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单备注")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes),
      expression: "notes"
    }],
    attrs: {
      "placeholder": "补充说明",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-options"
  }, [_c('p', {
    staticClass: "total"
  }, [_c('span', {
    staticClass: "total-name"
  }, [_vm._v("预估金额：")]), _c('span', {
    staticClass: "price"
  }, [_vm._v("¥" + _vm._s(_vm.totalPrice))])]), _vm._v(" "), _c('button', {
    staticClass: "place-order",
    attrs: {
      "disabled": _vm.placingOrder
    },
    on: {
      "click": function($event) {
        return _vm.placeOrder()
      }
    }
  }, [_vm._v("\n          提交订单\n      ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delivery-fee"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("配送费")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("¥0")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4ee982ea"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Checkout.vue
// module id = 540
// module chunks = 1